import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSelectionList = createCustomElementWrapper('kat-selection-list', 'KatSelectionList', {}, {
    'onChange': 'change',
}, [
    'title',
]);
